import { SHIFTS } from "@/constants/shifts";

const cell = (item) => {
  const ordered = Number(item?.quantity) || 0;
  const taken = Number(item?.payed) || 0;
  return {
    ordered,
    taken,
    percent: ordered ? Math.min(100, Math.round((taken / ordered) * 100)) : 0,
    complete: ordered > 0 && taken >= ordered,
  };
};

/**
 * Naručeno / Preuzeto (jela iz grupa): po firmi naručeno / preuzeto za svaku smenu i ukupno, sa razlikom. Zahteva
 * nasleđen stari tab ReportTabGroupMealsTabTaken (total, filters, customSearch).
 */
export default {
  computed: {
    allRows() {
      return this.total.map((item) => {
        const row = {
          id: item.company_id,
          name: item.menu,
          source: item,
          ...cell(item.total),
        };
        SHIFTS.forEach((shift) => {
          row[shift.key] = cell(item[shift.key]);
        });
        row.difference = row.ordered - row.taken;
        return row;
      });
    },
    matchedRows() {
      return this.filters.search ? this.customSearch(this.allRows, [{ value: "name" }], this.filters.search) : this.allRows;
    },
  },
  methods: {
    /** Zbir redova (naručeno, preuzeto, razlika i po smeni). */
    summarize(rows) {
      const summary = { ordered: 0, taken: 0, difference: 0 };
      SHIFTS.forEach((shift) => {
        summary[shift.key] = { ordered: 0, taken: 0 };
      });
      rows.forEach((row) => {
        summary.ordered += row.ordered;
        summary.taken += row.taken;
        SHIFTS.forEach((shift) => {
          summary[shift.key].ordered += row[shift.key].ordered;
          summary[shift.key].taken += row[shift.key].taken;
        });
      });
      summary.difference = summary.ordered - summary.taken;
      return summary;
    },
    /** Radnici firme: ista firma u Korisnicima (isti izbor u store-u kao i u starom tabu). */
    selectCompanyForUsers(item) {
      this.$store.commit("report/SET_SELECTED_COMPANY", {
        id: item.company_id,
        name: item.menu,
        company: item.menu,
      });
    },
  },
};
